import { render, staticRenderFns } from "./city.vue?vue&type=template&id=10fec006&scoped=true&"
import script from "./city.vue?vue&type=script&lang=js&"
export * from "./city.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fec006",
  null
  
)

export default component.exports